/**
 * Created by Rodrigo Quesada on 05/02/17.
 */
import * as moment from 'moment';
import {IdentifiedModel} from '../../common/identified-model.class';
import {ModelMixin} from '../../common/model.class';
import Moment = moment.Moment;

export class LifeCertification extends ModelMixin() implements IdentifiedModel<LifeCertification> {

    TYPE = LifeCertification;

    id: string;
    certificationType?: string;
    expirationDate?: Moment;

    constructor(jsonData: any = {}) {
        super();
        if (jsonData.expirationDate) jsonData.expirationDate = moment(jsonData.expirationDate);
        Object.assign(this, jsonData);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/licenses-certifications/lifecertification/life-certification.model.ts